// @ts-ignore
import * as ramda from 'ramda';

/**
 * Takes an object with a key of a core entity type (leads|contacts|accounts)
 * and returns another object with the same key, containing a an array of field
 * names, which were split and decoded by comma
 * @param  {Object} fields   Object containing a comma-separated string of field names
 * @return {Object}          Object with an array field names under a single
 *                                  core entity type key
 */
export function deserializeFields(fields: {[entityType: string]: string}): {
    [entityType: string]: Array<string>;
} {
    // @ts-ignore
    return ramda.map((keyFields) => deserializeFieldNames(keyFields), fields);
}

/**
 * Converts an array of field names into a encoded url string, separated by
 * commas
 *
 * @param {string} fieldNames - A comma-separated string of field names to be decoded and split
 * @return {string[]} -           Array of decoded field name strings
 */
export function deserializeFieldNames(fieldNames: string): Array<string> {
    const fieldArray = fieldNames.split(',').map((fieldName) => {
        // Custom fields can contain non url-safe characters (%, &, etc.)
        // Prevent crashing the page if an unsafe field name is shown
        try {
            return decodeURIComponent(fieldName);
        } catch (error: any) {
            return fieldName;
        }
    });
    const fieldArrayWithoutName = fieldArray.filter((x) => x !== 'name');

    return ['name'].concat(fieldArrayWithoutName);
}
